<script context="module">
  import { Client, getLanguage } from '../utils/prismicHelpers';

  export async function load({ session, error, status }) {
    const { LANGUAGE } = session;
    const doc = await Client().getSingle('rco', {
      lang: getLanguage(LANGUAGE),
    });

    if (doc) {
      return {
        props: {
          doc,
        },
      };
    } else {
      return {
        error,
        status,
      };
    }
  }
</script>

<script>
  import CallToAction from '../components/CallToAction.svelte';
  import SliceZone from '../components/SliceZone.svelte';
  import Head from '../components/Head.svelte';

  import { _ } from 'svelte-i18n';
  import Error from './__error.svelte';

  export let doc;
</script>

<Head {doc} />

<SliceZone slices={doc.data.body} />

<CallToAction />
